module.exports = __webpack_public_path__ + "images/goldstar-11a9e5bc13ef23949a7fda55f49bf197.gif";